import React, { useState, useEffect, useRef } from "react";
import Col from "react-bootstrap/Col";
import "./AlertNotification.scss";

const AlertNotifications = ({ message }) => {
  const [alertMessages, setAlertMessages] = useState("");
  console.log("Message", alertMessages);
  const contentRef = useRef(null);
  const wrapperRef = useRef(null);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    setAlertMessages(message);
  }, [message]);

  useEffect(() => {
    const contentWidth = contentRef.current?.offsetWidth || 0;
    const wrapperWidth = wrapperRef.current?.offsetWidth || 0;
    const distance = contentWidth + wrapperWidth;
    const speed = 100; // pixels per second

    setDuration(distance / speed);
  }, [alertMessages]);

  return (
    <>
      <Col xs={12} className="d-flex justify-content-start">
        <div className="scrolling-alert-wrapper" ref={wrapperRef}>
          <div
            className="scrolling-alert-content"
            ref={contentRef}
            style={{
              animation: `scroll-left ${duration}s linear infinite`,
            }}
          >
            {Array.isArray(alertMessages) &&
              alertMessages.map((item) => (
                <span key={item.id} className="mr-4">
                  {item.Message}
                </span>
              ))}
          </div>
        </div>
      </Col>
    </>
  );
};

export default AlertNotifications;
